<script lang="ts">
import SectionCheckReceivedList from '@/generated/sections/SectionCheckReceivedList.vue';
import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
import Delivery, { DeliveryTypes } from '@/generated/classes/Delivery';
import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
import { Modules, Sections } from '@/generated/classes/AppSchema';
import { storeTransaction, storeDelivery } from '@/generated/stores';
import Route from '@/extend/classes/Route';
import Section from '@/framework/base/classes/Section';
import SectionCheckReceived from '@/extend/sections/SectionCheckReceivedExtend.vue';
import SectionDelivery from '@/extend/sections/SectionDeliveryExtend.vue';
import Button from '@/framework/base/classes/Button';
import Transaction from '../classes/Transaction';
import { CiRouter } from '@/framework/base/helpers/NavHelper';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SectionCheckReceivedList,
    data() {
        const buttons: Button[] = [];

        return {
            openDelivery: false,
            delivery: new Delivery(),
            buttons
        };
    },
    computed: {
        headers() {
            return [
                { text: "Date de réception", value: 'dateProcess', cellClass: '', sortable: true },
                { text: "Emetteur", value: 'ownerLabel', cellClass: '', sortable: true },
                { text: "Référence", value: 'reference', cellClass: '', sortable: true },
                { text: "Montant", value: 'amount', cellClass: '', sortable: true },
                { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
            ];
        },
        section(): Section {
            const section = new Section();
            section.ressource = this.ressource;
            section.picto = 'SectionIdentitePicto';

            if (this.openDelivery) {
                section.component = SectionDelivery;
                const delivery = storeDelivery.createNewDelivery();
                delivery.type = this.delivery.type;
                delivery.reference = this.delivery.reference;
                delivery.count = this.delivery.count;
                delivery.amount = this.delivery.amount;
                section.data = delivery;
                section.type = 'delivery';
            } else {
                section.component = SectionCheckReceived;
                section.data = storeTransaction.createNewTransaction();
                section.type = 'transaction';
            }
            section.autoSave = false;
            return section;
        },
        extraButtons(): Button[] {
            if (this.buttons.length == 0 && this.totalCount > 0) {
                const delivery = new Button();
                delivery.label = 'générer remise';
                delivery.show = true;
                delivery.disabled = this.totalCount < 1;
                delivery.outlined = false;
                delivery.loading = false;
                delivery.callback = () => this.deliveryCallback(delivery);
                this.addButton(delivery);
            }
            return this.buttons;
        }
    },
    methods: {
        addButton(button: Button) {
            this.buttons.push(button);
        },
        defaultFilter(): void {
            {
                const columnFilter = new ColumnFilter();
                columnFilter.name = "type";
                columnFilter.staticFilter = true;
                const choix = new ListChoix();
                choix.value = TransactionTypes.CHEQUE_RECU;
                columnFilter.filters.push(choix);
                this.activeFilters.push(columnFilter);
            }
            {
                const columnFilter = new ColumnFilter();
                columnFilter.name = "statut";
                columnFilter.staticFilter = true;
                const choix = new ListChoix();
                choix.value = TransactionStatuts.RECEIVED;
                columnFilter.filters.push(choix);
                this.activeFilters.push(columnFilter);
            }
        },
        addItem(): void {
            this.dialogOpen = true;
        },
        hasDocument(transaction: Transaction): boolean {
            return transaction.documentId > 0;
        },
        deliveryCallback(button: Button): Promise<void> {
            button.loading = true;
            return new Promise((resolve) => {
                this.delivery.type = DeliveryTypes.CHEQUE;
                Delivery.checkDelivery(this.delivery).then((res) => {
                    this.delivery = res;
                    this.openDelivery = true;
                    this.dialogOpen = true;
                    button.loading = false;
                })
                resolve();
            });
        },
        selectItem(item: unknown): void {
            const obj = item as Transaction;
            if (this.hasDocument(obj)) {
                const route = new Route();
                route.module = Modules.DOCUMENT;
                route.sectionObjId = obj.documentId;
                route.section = Sections.DOCUMENT_VIEWER;
                route.isDialog = true;
                CiRouter.addRoute(route);
            }
        },
        displayDocument(transaction: Transaction): void {
            const route = new Route();
            route.module = Modules.DOCUMENT;
            route.sectionObjId = transaction.documentId;
            route.section = Sections.DOCUMENT_VIEWER;
            route.isDialog = true;
            CiRouter.addRoute(route);
        },
        closeSection(): void {
            this.openDelivery = false;
            this.$emit('closeDialog');
        }
    }
})

</script>
